// extracted by mini-css-extract-plugin
module.exports = {"tabHead":"tabHead-3ggCLOYq","tabHeadItem":"tabHeadItem-3-ZPkvz4","current":"current-1NI4FA0a","fix":"fix-1l2bc7Mw"};